import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Button from 'layout/atoms/Button/Button';
import InfoBox from 'layout/atoms/InfoBox/InfoBox';
import Grid from 'layout/molecules/Grid/Grid';
import VisualEditor from 'layout/organisms/VisualEditor/VisualEditor';
import { closeSidebar, openModal } from 'store/layoutSlice';
import { selectSpecificationPreviewItem } from 'store/specificationPreviewSlice';
import { fetchSpecificationProjection, fetchSpecificationProjections, selectSpecificationProjections, selectSpecificationProjectionsRefetchFlags, selectSpecificationProjectionsStatus, setZoom, } from 'store/specificationProjectionsSlice';
function Comments() {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation(['specification', 'common']);
    const specificationPreview = useSelector(selectSpecificationPreviewItem);
    const specificationId = specificationPreview.id;
    const status = useSelector(selectSpecificationProjectionsStatus);
    const refetchFlag = useSelector(selectSpecificationProjectionsRefetchFlags);
    const projections = useSelector(selectSpecificationProjections);
    const [activeProjection, setActiveProjection] = useState(null);
    useEffect(() => {
        dispatch(setZoom(70));
    }, [dispatch]);
    useEffect(() => {
        if (status.fetch === 'succeeded' && projections.length > 0 && !activeProjection) {
            setActiveProjection(projections[0].id);
        }
    }, [status.fetch, projections, activeProjection]);
    useEffect(() => {
        if ((status.fetch === 'idle' || refetchFlag.fetch) && specificationId) {
            dispatch(fetchSpecificationProjections({ specificationId }));
        }
    }, [dispatch, status.fetch, refetchFlag.fetch, specificationId]);
    useEffect(() => {
        if (activeProjection) {
            dispatch(fetchSpecificationProjection({ specificationProjectionId: activeProjection }));
        }
    }, [dispatch, activeProjection]);
    const handleSpecificationLink = (route) => {
        if ((specificationPreview === null || specificationPreview === void 0 ? void 0 : specificationPreview.state) === 'DRAFT') {
            dispatch(openModal({ name: 'specificationCreator', data: { id: specificationPreview === null || specificationPreview === void 0 ? void 0 : specificationPreview.id } }));
        }
        else {
            dispatch(closeSidebar({ name: 'specificationPreview' }));
            setTimeout(() => history.push(route), 300 - 10);
        }
    };
    return (React.createElement(Grid, { gap: 24 },
        React.createElement(InfoBox, { type: "info", text: t('projections_count', { count: projections.length }), aside: specificationPreview.state !== 'PRODUCTION' && (React.createElement(Button, { theme: "ghost", onClick: () => handleSpecificationLink(`/specifications/details/${specificationPreview === null || specificationPreview === void 0 ? void 0 : specificationPreview.id}/comments`) }, t('common:maintenance'))), noBorder: true }),
        projections.length > 0 && (React.createElement(VisualEditor, { preview: true, menu: status.fetch === 'succeeded' &&
                projections.map((projection) => (React.createElement(Button, { key: projection.id, theme: projection.id === activeProjection ? 'fill' : 'ghost', onClick: () => setActiveProjection(projection.id) }, projection.name))) }))));
}
export default Comments;
